import Vue from 'vue'
import Router from 'vue-router'

import WhatsNew from '@/views/WhatsNew'

import Login from '@/views/Login'
import Register from '@/views/Register'

import ResetPasswordInit from '@/views/Accounts/ResetPasswordInit'
import ResetPassword from '@/views/Accounts/ResetPassword'
import EmailReset from '@/views/EmailReset'
import AccountActivation from '@/views/Accounts/Activation'

import Billing from '@/views/Billing/Billing'

import Plans from '@/views/Billing/Plans'
import Plan from '@/views/Billing/Plan'
import EditPlan from '@/views/Billing/EditPlan'

import PaymentMethods from '@/views/Billing/PaymentMethods'
import AddPaymentMethod from '@/views/Billing/AddPaymentMethod'
import EndSubscriptionTrial from '@/views/Billing/EndSubscriptionTrial'

import Invoices from '@/views/Billing/Invoices'
import Invoice from '@/views/Billing/Invoice'

import PaymentSuccess from '@/views/Billing/PaymentSuccess'
import PaymentCancelled from '@/views/Billing/PaymentCancelled'

import Users from '@/views/Users'
import User from '@/views/User'
import AddUser from '@/views/AddUser'
import EditUser from '@/views/EditUser'

import CompanyUsers from '@/views/CompanyUsers'
import CompanyUser from '@/views/CompanyUser'
import AddCompanyUser from '@/views/AddCompanyUser'
import EditCompanyUser from '@/views/EditCompanyUser'

import Companies from '@/views/Companies'
import Company from '@/views/Company'
import Websites from '@/views/Websites'
import AddCompany from '@/views/AddCompany'
import EditCompany from '@/views/EditCompany'

import DomainSearch from '@/views/DomainSearch'
import DomainContactDetails from '@/views/DomainContactDetails'

import CompanyDomains from '@/views/CompanyDomains'
import CompanyDomain from '@/views/CompanyDomain'
import EditDomainUrlForwarding from '@/views/EditDomainUrlForwarding'
import AddDomainUrlForwarding from '@/views/AddDomainUrlForwarding'

import Site from '@/views/Site'
import DeleteSite from '@/views/DeleteSite'

import Themes from '@/views/Themes'
import AddTheme from '@/views/AddTheme'
import EditTheme from '@/views/EditTheme'

import Templates from '@/views/Templates'
import AddTemplate from '@/views/AddTemplate'
import EditTemplate from '@/views/EditTemplate'

import AdminSites from '@/views/AdminSites'

import ListTypes from '@/views/ListTypes'
import AddListType from '@/views/AddListType'
import ListType from '@/views/ListType'
import EditListType from '@/views/EditListType'

import SiteOnboardingVideo from '@/views/guides/onboarding/Video'
import SiteOnboardingIntro from '@/views/guides/onboarding/Intro'
import SiteOnboardingPages from '@/views/guides/onboarding/Pages'
import SiteOnboardingSettings from '@/views/guides/onboarding/Settings'
import SiteOnboardingThemes from '@/views/guides/onboarding/Themes'
import SiteOnboardingColours from '@/views/guides/onboarding/Colours'
import SiteOnboardingFonts from '@/views/guides/onboarding/Fonts'
import SiteOnboardingLaunch from '@/views/guides/onboarding/Launch'

import EditSiteDomain from '@/views/EditSiteDomain'

import DomainLogin from '@/views/guides/DomainLogin'
import DomainDnsManagement from '@/views/guides/DomainDnsManagement'
import DomainDnsConfig from '@/views/guides/DomainDnsConfig'
import DomainDnsCheck from '@/views/guides/DomainDnsCheck'
import DomainComplete from '@/views/guides/DomainComplete'
import DomainRequestForm from '@/views/guides/DomainRequestForm'

import EditSiteSettings from '@/views/EditSiteSettings'
import EditSiteVisibility from '@/views/EditSiteVisibility'
import EditSiteGtm from '@/views/EditSiteGtm'
import EditSiteAnalytics from '@/views/EditSiteAnalytics'

import AnalyticsCreateGoogleAccount from '@/views/guides/AnalyticsCreateGoogleAccount'
import AnalyticsCreateAnalyticsAccount from '@/views/guides/AnalyticsCreateAnalyticsAccount'
import AnalyticsAccess from '@/views/guides/AnalyticsAccess'
import AnalyticsAdmin from '@/views/guides/AnalyticsAdmin'
import AnalyticsSelectAccount from '@/views/guides/AnalyticsSelectAccount'
import AnalyticsCreateProperty from '@/views/guides/AnalyticsCreateProperty'
import AnalyticsSubmitDetails from '@/views/guides/AnalyticsSubmitDetails'
import AnalyticsSaveId from '@/views/guides/AnalyticsSaveId'

import Newsletter from '@/views/Newsletter'
import AddNewsletter from '@/views/AddNewsletter'
import EditSiteNewsletters from '@/views/EditSiteNewsletters'

import EditSiteShopify from '@/views/EditSiteShopify'
import ShopifyCreateStore from '@/views/guides/ShopifyCreateStore'
import ShopifyLocateChannels from '@/views/guides/ShopifyLocateChannels'
import ShopifyRemoveChannel from '@/views/guides/ShopifyRemoveChannel'
import ShopifyCompleteAccount from '@/views/guides/ShopifyCompleteAccount'
import ShopifyCreateApp from '@/views/guides/ShopifyCreateApp'
import ShopifyAppPermissions from '@/views/guides/ShopifyAppPermissions'
import ShopifyCredentials from '@/views/guides/ShopifyCredentials'

import Contact from '@/views/Contact'
import AddContact from '@/views/AddContact'
import EditSiteContacts from '@/views/EditSiteContacts'

import EditSiteFavicon from '@/views/EditSiteFavicon'
import EditSiteLogo from '@/views/EditSiteLogo'
import EditSiteFacebookPixel from '@/views/EditSiteFacebookPixel'
import EditSiteTheme from '@/views/EditSiteTheme'
import EditSiteColours from '@/views/EditSiteColours'
import EditSiteFonts from '@/views/EditSiteFonts'
import EditSiteCustomCss from '@/views/EditSiteCustomCss'
import EditSiteCustomJs from '@/views/EditSiteCustomJs'

import Pages from '@/views/Pages'
import Page from '@/views/Page'
import AddPage from '@/views/AddPage'

import Articles from '@/views/Articles'
import Article from '@/views/Article'
import AddArticle from '@/views/AddArticle'

import SiteSettingsList from '@/views/SiteSettingsList'
import SiteAppearanceList from '@/views/SiteAppearanceList'

import List from '@/views/List'
import AddList from '@/views/AddList'
import EditList from '@/views/EditList'

import EditListItem from '@/views/EditListItem'

import SiteSetup from '@/views/SiteSetup/SiteSetup'
import HomeListItem from '@/views/SiteSetup/HomeListItem'
import EditHomeListItem from '@/views/SiteSetup/EditHomeListItem'
import GetStarted from '@/views/SiteSetup/GetStarted'
import HomeContent from '@/views/SiteSetup/HomeContent'
import OtherContent from '@/views/SiteSetup/OtherContent'
import ServicesContent from '@/views/SiteSetup/ServicesContent'
import ReviewsContent from '@/views/SiteSetup/ReviewsContent'
import SocialMediaContent from '@/views/SiteSetup/SocialMediaContent'
import LogoContent from '@/views/SiteSetup/LogoContent'
import OtherContentFinal from '@/views/SiteSetup/OtherContentFinal'
import SitePreview from '@/views/SiteSetup/SitePreview'

import OutboundLink from '@/views/OutboundLink'

import AdminActions from '@/views/AdminActions'
import AdminWebsite from '@/views/AdminActions/AdminWebsite'
import AdminGallery from '@/views/AdminActions/AdminGallery'
import AdminReviews from '@/views/AdminActions/AdminReviews'
import AdminPageCreator from '@/views/AdminActions/AdminPageCreator'
import AdminCertificate from '@/views/AdminActions/AdminCertificate'
import AdminReplaceListItemImages from '@/views/AdminActions/AdminReplaceListItemImages'
import AdminReplaceListItemImagesBackup from '@/views/AdminActions/AdminReplaceListItemImagesBackup'
import AdminReplaceContactPages from '@/views/AdminActions/AdminReplaceContactPages'
import AdminWhiteLabelCompanies from '@/views/AdminActions/AdminWhiteLabelCompanies'
import AdminReplaceLogos from '@/views/AdminActions/AdminReplaceLogos'
import AdminProductList from '@/views/AdminActions/ProductListImportForm'
import AdminReplaceTemplates from '@/views/AdminActions/AdminReplaceTemplates'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'is-active',
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      name: 'whats-new',
      component: WhatsNew
    },

    {
      path: '/actions',
      name: 'admin-actions',
      component: AdminActions
    },

    {
      path: '/actions/admin-website/:companyId',
      name: 'admin-website',
      component: AdminWebsite,
      props: true
    },

    {
      path: '/actions/admin-gallery',
      name: 'admin-gallery',
      component: AdminGallery
    },

    {
      path: '/actions/admin-reviews',
      name: 'admin-reviews',
      component: AdminReviews
    },

    {
      path: '/actions/admin-pages',
      name: 'admin-pages',
      component: AdminPageCreator
    },

    {
      path: '/actions/admin-certificate',
      name: 'admin-certificate',
      component: AdminCertificate
    },

    {
      path: '/actions/admin-images',
      name: 'admin-images',
      component: AdminReplaceListItemImages
    },

    {
      path: '/actions/admin-images-backup',
      name: 'admin-images-backup',
      component: AdminReplaceListItemImagesBackup
    },

    {
      path: '/actions/admin-contact-pages',
      name: 'admin-contact-pages',
      component: AdminReplaceContactPages
    },

    {
      path: '/actions/admin-whitelabel-companies',
      name: 'admin-whitelabel-companies',
      component: AdminWhiteLabelCompanies
    },

    {
      path: '/actions/admin-replace-logos',
      name: 'admin-replace-logos',
      component: AdminReplaceLogos
    },

    {
      path: '/actions/admin-replace-templates',
      name: 'admin-replace-templates',
      component: AdminReplaceTemplates
    },

    {
      path: '/actions/admin-product-list',
      name: 'admin-product-list',
      component: AdminProductList
    },

    {
      path: '/login',
      name: 'login',
      component: Login
    },

    {
      path: '/sign-up',
      name: 'register',
      component: Register
    },

    {
      path: '/accounts/reset-password',
      name: 'reset-password-init',
      component: ResetPasswordInit
    },

    {
      path: '/accounts/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
      props: true
    },

    {
      path: '/:companyId/users/:userId/email_reset/:token',
      name: 'email-reset',
      component: EmailReset,
      props: true
    },

    {
      path: '/accounts/activation/:token',
      name: 'account-activation',
      component: AccountActivation,
      props: true
    },

    {
      path: '/users',
      name: 'users',
      component: Users,
      props: (route) => Object.assign({}, route.params, route.query),
      children: [
        {
          path: 'new',
          name: 'add-user',
          component: AddUser,
          props: true
        },
        {
          path: ':userId/edit',
          name: 'edit-user',
          component: EditUser,
          props: true
        }
      ]
    },
    {
      path: '/users/:userId',
      name: 'user',
      component: User,
      props: (route) => Object.assign({}, route.params, route.query),
      children: [
        {
          path: 'edit',
          name: 'edit-user',
          component: EditUser,
          props: true
        }
      ]
    },

    {
      path: '/companies',
      name: 'companies',
      component: Companies,
      props: (route) => Object.assign({}, route.params, route.query),
      children: [
        {
          path: 'new',
          name: 'add-company',
          component: AddCompany,
          props: true
        }
      ]
    },

    {
      path: '/:companyId',
      name: 'company',
      component: Company,
      props: (route) => Object.assign({}, route.params, route.query)
    },

    {
      path: '/:companyId/websites',
      name: 'websites',
      component: Websites,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'websites'
      }
    },

    {
      path: '/:companyId/team',
      name: 'company-users',
      component: CompanyUsers,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'team'
      },
      children: [
        {
          path: 'add-company-user',
          name: 'add-company-user',
          component: AddCompanyUser,
          props: true,
          meta: {
            menuName: 'team'
          }
        }
      ]
    },

    {
      path: '/:companyId/billing',
      name: 'billing',
      component: Billing,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'billing'
      }
    },

    {
      path: '/:companyId/billing/plans',
      name: 'plans',
      component: Plans,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'billing'
      },
      children: [
        {
          path: ':siteId',
          name: 'plan',
          component: Plan,
          props: true,
          meta: {
            menuName: 'billing'
          }
        },
        {
          path: ':siteId/edit',
          name: 'edit-plan',
          component: EditPlan,
          props: true,
          meta: {
            menuName: 'billing'
          }
        }
      ]
    },

    {
      path: '/:companyId/billing/payment-methods',
      name: 'payment-methods',
      component: PaymentMethods,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'billing'
      },
      children: [
        {
          name: 'add-payment-method',
          path: 'add-payment-method',
          component: AddPaymentMethod,
          props: true,
          meta: {
            menuName: 'billing'
          }
        }
      ]
    },

    {
      path: '/:companyId/billing/invoices',
      name: 'invoices',
      component: Invoices,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'billing'
      },
      children: [
        {
          name: 'invoice',
          path: ':invoiceId',
          component: Invoice,
          props: true,
          meta: {
            menuName: 'billing'
          }
        }
      ]
    },

    {
      name: 'end-trial',
      path: '/end-trial/:siteId',
      component: EndSubscriptionTrial,
      props: true,
      meta: {
        menuName: 'billing'
      }
    },
    {
      name: 'payment-success',
      path: '/success',
      component: PaymentSuccess,
      meta: {
        menuName: 'billing'
      }
    },
    {
      name: 'payment-cancelled',
      path: '/cancelled',
      component: PaymentCancelled,
      meta: {
        menuName: 'billing'
      }
    },

    {
      path: '/:companyId/user/:userId',
      name: 'company-user',
      component: CompanyUser,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'team'
      },
      children: [
        {
          path: 'edit-company-user',
          name: 'edit-company-user',
          component: EditCompanyUser,
          props: true
        },
        {
          path: 'edit-company',
          name: 'edit-company',
          component: EditCompany,
          props: true
        }
      ]
    },

    {
      path: '/:companyId/site-setup',
      name: 'siteSetup',
      component: SiteSetup,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        hideSidebar: true
      },
      children: [
        {
          name: 'getStarted',
          path: 'start',
          component: GetStarted,
          meta: {
            hideSidebar: true
          },
          props: true
        },
        {
          name: 'homeContent',
          path: ':siteId/generated-content',
          component: HomeContent,
          props: true,
          meta: {
            hideSidebar: true,
            isLanding: true
          },
          children: [
            {
              name: 'showHomeContent',
              path: 'page/:pageId/list/:listId/:index/item/:listItemId',
              component: HomeListItem,
              props: true,
              meta: {
                hideSidebar: true
              }
            },
            {
              name: 'editHomeContent',
              path: 'page/:pageId/list/:listId/:index/item/:listItemId/edit',
              component: EditHomeListItem,
              props: true,
              meta: {
                hideSidebar: true
              }
            }
          ]
        },
        {
          name: 'otherContent',
          path: ':siteId/other-content',
          component: OtherContent,
          meta: {
            hideSidebar: true,
            isLanding: true
          },
          props: (route) => Object.assign({}, route.params, route.query),
          children: [
            {
              name: 'servicesContent',
              path: 'services',
              component: ServicesContent,
              meta: {
                hideSidebar: true
              },
              props: (route) => Object.assign({}, route.params, route.query)
            },
            {
              name: 'reviewsContent',
              path: 'reviews',
              component: ReviewsContent,
              meta: {
                hideSidebar: true
              },
              props: (route) => Object.assign({}, route.params, route.query)
            },
            {
              name: 'socialMediaContent',
              path: 'social-platforms',
              component: SocialMediaContent,
              meta: {
                hideSidebar: true
              },
              props: (route) => Object.assign({}, route.params, route.query)
            },
            {
              name: 'logoContent',
              path: 'logo',
              component: LogoContent,
              meta: {
                hideSidebar: true
              },
              props: true
            },
            {
              name: 'otherContentFinal',
              path: 'final',
              component: OtherContentFinal,
              meta: {
                hideSidebar: true
              }
            }
          ]
        },
        {
          name: 'sitePreview',
          path: ':siteId/site-preview',
          component: SitePreview,
          meta: {
            hideSidebar: true
          },
          props: true
        }
      ]
    },

    {
      name: 'domain-search',
      path: '/:companyId/domain-search',
      component: DomainSearch,
      props: true,
      meta: {
        menuName: 'domains'
      },
      children: [
        {
          name: 'domain-contact-details',
          path: 'contact-details',
          component: DomainContactDetails,
          props: true,
          meta: {
            menuName: 'domains'
          }
        },
        {
          name: 'company-domain-invoice',
          path: 'invoice/:invoiceId',
          component: Invoice,
          props: true,
          meta: {
            menuName: 'domains'
          }
        }
      ]
    },

    {
      name: 'company-domains',
      path: '/:companyId/domains',
      component: CompanyDomains,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        menuName: 'domains'
      }
    },

    {
      name: 'company-domain',
      path: '/:companyId/domains/:domain',
      component: CompanyDomain,
      props: true,
      meta: {
        menuName: 'domains'
      },
      children: [
        {
          name: 'connect-company-domain',
          path: 'connect/:siteId',
          component: DomainDnsCheck,
          props: true,
          meta: {
            menuName: 'domains'
          }
        },
        {
          name: 'add-domain-forwarding',
          path: 'add-forwarding',
          component: AddDomainUrlForwarding,
          props: true,
          meta: {
            menuName: 'domains'
          }
        },
        {
          name: 'edit-domain-forwarding',
          path: 'edit-forwarding/:host',
          component: EditDomainUrlForwarding,
          props: true,
          meta: {
            menuName: 'domains'
          }
        }
      ]
    },

    {
      path: '/:companyId/websites/:siteId',
      name: 'site',
      component: Site,
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        tier: 1,
        hideSidebar: true
      },
      children: [
        {
          path: 'select-plan',
          name: 'site-select-plan',
          component: Plan,
          props: true,
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/video',
          name: 'onboarding-video',
          component: SiteOnboardingVideo,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/intro',
          name: 'onboarding-intro',
          component: SiteOnboardingIntro,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/pages',
          name: 'onboarding-pages',
          component: SiteOnboardingPages,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/settings',
          name: 'onboarding-settings',
          component: SiteOnboardingSettings,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/themes',
          name: 'onboarding-themes',
          component: SiteOnboardingThemes,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/colours',
          name: 'onboarding-colours',
          component: SiteOnboardingColours,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/fonts',
          name: 'onboarding-fonts',
          component: SiteOnboardingFonts,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },
        {
          path: 'onboarding/launch',
          name: 'onboarding-launch',
          component: SiteOnboardingLaunch,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            hideSidebar: true
          }
        },

        {
          path: 'pages',
          name: 'pages',
          component: Pages,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            tier: 2,
            hideSidebar: true,
            backLink: 'site'
          },
          children: [
            {
              path: 'add',
              name: 'add-page',
              component: AddPage,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'pages'
              }
            },
            {
              path: ':pageId',
              name: 'page',
              component: Page,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'pages'
              },
              children: [
                {
                  name: 'list',
                  path: 'list/:listId',
                  component: List,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'page'
                  }
                },
                {
                  name: 'add-list',
                  path: 'add-list',
                  component: AddList,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'page'
                  }
                },
                {
                  name: 'edit-list',
                  path: 'edit-list',
                  component: EditList,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'page'
                  }
                },
                {
                  path: 'list/:listId/edit-list-item/:listItemId',
                  name: 'EditListItem',
                  component: EditListItem,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'page'
                  }
                }
              ]
            }
          ]
        },

        {
          path: 'articles',
          name: 'articles',
          component: Articles,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            tier: 2,
            hideSidebar: true,
            backLink: 'site'
          },
          children: [
            {
              path: 'add',
              name: 'add-article',
              component: AddArticle,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'articles'
              }
            },
            {
              path: ':articleId',
              name: 'article',
              component: Article,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'articles'
              }
            }
          ]
        },

        {
          path: 'settings',
          name: 'settings',
          component: SiteSettingsList,
          props: true,
          meta: {
            tier: 2,
            hideSidebar: true,
            backLink: 'site'
          },
          children: [
            {
              path: 'general-settings',
              name: 'general-settings',
              component: EditSiteSettings,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            },
            {
              path: 'domain-settings',
              name: 'domain-settings',
              component: EditSiteDomain,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              },
              children: [
                {
                  path: 'domain-login',
                  name: 'domain-login',
                  component: DomainLogin,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'domain-dns-management',
                  name: 'domain-dns-management',
                  component: DomainDnsManagement,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'domain-dns-config',
                  name: 'domain-dns-config',
                  component: DomainDnsConfig,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'domain-dns-check',
                  name: 'domain-dns-check',
                  component: DomainDnsCheck,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'domain-complete',
                  name: 'domain-complete',
                  component: DomainComplete,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'domain-request-form',
                  name: 'domain-request-form',
                  component: DomainRequestForm,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                }
              ]
            },
            {
              path: 'custom-js-settings',
              name: 'custom-js-settings',
              component: EditSiteCustomJs,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'appearance'
              }
            },
            {
              path: 'logo-settings',
              name: 'logo-settings',
              component: EditSiteLogo,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            },
            {
              path: 'visibility-settings',
              name: 'visibility-settings',
              component: EditSiteVisibility,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            },

            {
              path: 'analytics-settings',
              name: 'analytics-settings',
              component: EditSiteAnalytics,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              },
              children: [
                {
                  path: 'analytics-create-google-account',
                  name: 'analytics-create-google-account',
                  component: AnalyticsCreateGoogleAccount,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-create-analytics-account',
                  name: 'analytics-create-analytics-account',
                  component: AnalyticsCreateAnalyticsAccount,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-access',
                  name: 'analytics-access',
                  component: AnalyticsAccess,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-admin',
                  name: 'analytics-admin',
                  component: AnalyticsAdmin,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-select-account',
                  name: 'analytics-select-account',
                  component: AnalyticsSelectAccount,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-create-property',
                  name: 'analytics-create-property',
                  component: AnalyticsCreateProperty,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-submit-details',
                  name: 'analytics-submit-details',
                  component: AnalyticsSubmitDetails,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'analytics-save-id',
                  name: 'analytics-save-id',
                  component: AnalyticsSaveId,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                }
              ]
            },
            {
              path: 'gtm-settings',
              name: 'gtm-settings',
              component: EditSiteGtm,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            },
            {
              path: 'shopify-settings',
              name: 'shopify-settings',
              component: EditSiteShopify,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              },
              children: [
                {
                  path: 'create-store',
                  name: 'create-store',
                  component: ShopifyCreateStore,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'locate-sales-channels',
                  name: 'locate-sales-channels',
                  component: ShopifyLocateChannels,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'remove-sales-channel',
                  name: 'remove-sales-channel',
                  component: ShopifyRemoveChannel,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'complete-sign-up',
                  name: 'complete-sign-up',
                  component: ShopifyCompleteAccount,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'shopify-create-app',
                  name: 'shopify-create-app',
                  component: ShopifyCreateApp,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'shopify-app-permissions',
                  name: 'shopify-app-permissions',
                  component: ShopifyAppPermissions,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                },
                {
                  path: 'shopify-credentials',
                  name: 'shopify-credentials',
                  component: ShopifyCredentials,
                  props: (route) =>
                    Object.assign({}, route.params, route.query),
                  meta: {
                    tier: 3,
                    hideSidebar: true,
                    backLink: 'settings'
                  }
                }
              ]
            },
            {
              path: 'favicon-settings',
              name: 'favicon-settings',
              component: EditSiteFavicon,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            },
            {
              path: 'facebook-pixel-settings',
              name: 'facebook-pixel-settings',
              component: EditSiteFacebookPixel,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            },
            {
              path: 'delete-site',
              name: 'delete-site',
              component: DeleteSite,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'settings'
              }
            }
          ]
        },
        {
          path: 'contact-settings',
          name: 'contact-settings',
          component: EditSiteContacts,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            tier: 2,
            hideSidebar: true,
            backLink: 'settings'
          },
          children: [
            {
              path: 'add',
              name: 'add-contact',
              component: AddContact,
              props: true,
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'contact-settings'
              }
            },
            {
              path: ':contactId',
              name: 'contact',
              component: Contact,
              props: true,
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'contact-settings'
              }
            }
          ]
        },
        {
          path: 'appearance',
          name: 'appearance',
          component: SiteAppearanceList,
          props: true,
          meta: {
            tier: 2,
            hideSidebar: true,
            backLink: 'site'
          },
          children: [
            {
              path: 'theme-settings',
              name: 'theme-settings',
              component: EditSiteTheme,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'appearance'
              }
            },
            {
              path: 'colour-palette',
              name: 'colour-palette',
              component: EditSiteColours,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'appearance'
              }
            },
            {
              path: 'fonts',
              name: 'fonts',
              component: EditSiteFonts,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'appearance'
              }
            },
            {
              path: 'custom-css-settings',
              name: 'custom-css-settings',
              component: EditSiteCustomCss,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'appearance'
              }
            }
          ]
        },
        {
          path: 'newsletter-settings',
          name: 'newsletter-settings',
          component: EditSiteNewsletters,
          props: (route) => Object.assign({}, route.params, route.query),
          meta: {
            tier: 2,
            hideSidebar: true,
            backLink: 'site'
          },
          children: [
            {
              path: 'newsletter',
              name: 'newsletter',
              component: Newsletter,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'newsletter-settings'
              }
            },
            {
              path: 'add',
              name: 'add-newsletter',
              component: AddNewsletter,
              props: (route) => Object.assign({}, route.params, route.query),
              meta: {
                tier: 3,
                hideSidebar: true,
                backLink: 'newsletter-settings'
              }
            }
          ]
        }
      ]
    },

    {
      path: '/templates',
      name: 'templates',
      component: Templates,
      children: [
        {
          path: 'add',
          name: 'add-template',
          component: AddTemplate
        },
        {
          path: ':templateId',
          name: 'template',
          component: EditTemplate,
          props: true
        }
      ]
    },

    {
      path: '/admin-sites',
      name: 'admin-sites',
      component: AdminSites,
      props: (route) => Object.assign({}, route.params, route.query)
    },

    {
      path: '/list-types',
      name: 'list-types',
      component: ListTypes,
      children: [
        {
          path: 'add',
          name: 'add-list-type',
          component: AddListType
        }
      ]
    },

    {
      path: '/list-types/:listTypeId',
      name: 'list-type',
      component: ListType,
      props: (route) => Object.assign({}, route.params, route.query),
      children: [
        {
          path: 'edit',
          name: 'edit-list-type',
          component: EditListType,
          props: true
        }
      ]
    },

    {
      path: '/themes',
      name: 'themes',
      component: Themes,
      children: [
        {
          path: 'add',
          name: 'add-theme',
          component: AddTheme
        },
        {
          path: ':themeId',
          name: 'edit-theme',
          component: EditTheme,
          props: true
        }
      ]
    },

    {
      path: '/outbound-link',
      name: 'outbound-link',
      component: OutboundLink,
      props: true
    }
  ]
})
